import Feature from "../components/FeatureCardSection/FeatureCards";
import Footer from "../components/Footer/Footer";
export default function FeaturesPage() {
  return (
    <>
      <Feature />
      <Footer />
    </>
  );
}